import { useEffect, useState } from 'react';

import { db } from 'src/utils/firebase';
import { dateRangeForTransactions } from 'src/utils/rollup';
import _ from 'lodash';
import Rollup, { convertToUTC } from '../rollup';

export const useTransactionRollups = (userId) => {
  const [transactionRollups, setTransactionRollups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribe;

    // Check if userId is empty
    if (!userId) {
      setTransactionRollups([]); // Return an empty result
      setLoading(false);
    } else {
      setLoading(true);

      // Query to get the user's transaction_rollups sorted by timestamp in descending order
      const query = db
        .collection('transaction_rollup')
        .where('user_id', '==', userId)
        .orderBy('timestamp', 'desc');

      // Subscribe to the query and update state when data changes
      unsubscribe = query.onSnapshot((snapshot) => {
        console.log('transaction rollups updated...');
        const rollups = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          rollups.push({
            id: doc.id,
            ...data,
          });
        });

        setTransactionRollups(rollups);
        setLoading(false);
      });
    }

    // Cleanup the subscription when the component unmounts
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [userId]);

  const [income, setIncome] = useState(null);
  const [expenses, setExpenses] = useState(null);
  const [fullRange, setFullRange] = useState({});

  useEffect(() => {
    if (_.isEmpty(transactionRollups)) return;

    const range = dateRangeForTransactions(
      transactionRollups.map((e) => ({ ...e, date: convertToUTC(e.timestamp?.toDate()) }))
    );

    setFullRange(range);

    const incomeObjects = transactionRollups.map((series) => {
      const res = { ...series, transactions: series.income };
      delete res.expenses;
      delete res.income;
      return res;
    });
    setIncome(Rollup(range, incomeObjects));

    const expenseObject = transactionRollups.map((series) => {
      const res = { ...series, transactions: series.expenses };
      delete res.expenses;
      delete res.income;
      return res;
    });
    setExpenses(Rollup(range, expenseObject));
  }, [transactionRollups]);

  return { income, expenses, loading, fullRange };
};
